// "$1,234.50" for prices and totals. Missing values show as $0.00.
const formatMoney = (value: number | null | undefined) =>
  `$${(value ?? 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export default formatMoney;
